import React from 'react';
import ReactTooltip from 'react-tooltip';
import classnames from 'classnames';
import Icon from 'src/components/icon';
import { DefaultLoader } from 'src/components/loader';
import InputMask from 'react-input-mask';
import CurrencyInput from 'react-currency-input';

import './input.scss';

const Input = ({
    input,
    label,
    type,
    meta,
    theme,
    loading,
    showSuccessIcon,
    currencyInput,
    mask,
    ...rest
}) => {
    let inputComponent;
    if (mask) {
        inputComponent = (
            <InputMask
                mask={mask}
                maskChar=""
                type={type}
                data-tip={meta ? meta.error : null}
                {...input}
                {...rest}
            />
        );
    } else if (currencyInput) {
        inputComponent = (
            <CurrencyInput
                decimalSeparator=","
                thousandSeparator="."
                precision="2"
                prefix="R$ "
                data-tip={meta ? meta.error : null}
                {...input}
                {...rest}
            />
        );
    } else {
        inputComponent = (
            <input
                type={type}
                data-tip={meta ? meta.error : null}
                {...input}
                {...rest}
            />
        );
    }

    let helperElement;
    if (loading) {
        helperElement = <DefaultLoader className="helper-icon" color="grey" />;
    } else if (meta && meta.touched && meta.error) {
        helperElement = <Icon className="helper-icon error" code="times" size={12} />;
    } else if (meta && meta.touched && !meta.error && showSuccessIcon && input.value !== '') {
        helperElement = <Icon className="helper-icon success" code="check" size={12} />;
    }

    const tooltipWrapper = (meta && meta.touched && meta.error && meta.active)
        && (
            <ReactTooltip
                type="error"
                effect="solid"
                place="top"
                event="focus"
            />
        );

    return (
        <div
            className={classnames('InputWrapper', theme, {
                hasError: meta && meta.error && meta.touched,
            })}
        >
            <label htmlFor={rest.id}>{label}</label>
            <div>
                { inputComponent }
                { helperElement }
            </div>
            { tooltipWrapper }
        </div>
    );
};

export default Input;
